import {useContext, useEffect} from "react";
import {Form} from "antd";
import {SFormUploadImage, SGeneralForms} from "shj-components";
import {isEmpty} from "lodash-es";

import dayjs from "dayjs";
import {formatRelativeUploadData, formatUploadData} from "@/utils/file.ts";
import config from "@/config";
import measureContext from "./measureContext.ts";
import {measureRoomUpdateMeasureDtl} from "@/services/crmTool.ts";
import styles from "./index.module.less";
import {useFileUrlPrefix} from "shj-utils";
import {beforeUpload} from "@/pages/roomMeasurementTools/roomMeasurementManage/utils.ts";
import {trimStr} from "@/utils/data.ts";

export const Step4 = (props) => {
  const fileUrlPrefix = useFileUrlPrefix()
  const {detailInfo, setLoading} = useContext(measureContext)
  const {dictionaryData} = props;
  const [form] = Form.useForm()

  const disabledDate = (current) => {
    switch (detailInfo.houseStatus){
      case 'FUTURE_HOUSE':
        return current && current < dayjs().endOf('day');
      case 'EXISTING_HOUSE':
        return current && current > dayjs().endOf('day');
    }
  };

  useEffect(() => {
    if (!isEmpty(detailInfo)) {
      form.setFieldsValue({
        ...detailInfo,
        expectRenovationDate: detailInfo.expectRenovationDate ? dayjs(detailInfo.expectRenovationDate) : null,
        handoverDate: detailInfo.handoverDate ? dayjs(detailInfo.handoverDate) : null,
        competitorCompany: detailInfo.competitorCompany ? detailInfo.competitorCompany?.split(',') : null,
        estimatedRenovationTime: detailInfo.estimatedRenovationTime ? dayjs(detailInfo.estimatedRenovationTime) : null,
        lookingForwardToStayingTime: detailInfo.lookingForwardToStayingTime ? dayjs(detailInfo.lookingForwardToStayingTime) : null,
        roomSizeDiagram: detailInfo.roomSizeDiagram?.filter(item => item)?.map(item => (item.url ? item : {filePath: item, url: fileUrlPrefix + item})),
        checkInCertificate: detailInfo.checkInCertificate?.filter(item => item)?.map(item => (item.url ? item : {filePath: item, url: fileUrlPrefix + item})),

      })
    }
  }, [detailInfo]);

  const handleValues = (values) => {
    return {
      measureRoomId: detailInfo.measureRoomId,
      ...values,
      competitorCompany: values.competitorCompany ? values.competitorCompany?.join(',') : undefined,
      handoverDate: values.handoverDate ? dayjs(values.handoverDate).format('YYYY-MM-DD HH:mm:ss') : undefined,
      expectRenovationDate: values.expectRenovationDate ? dayjs(values.expectRenovationDate).format('YYYY-MM-DD HH:mm:ss') : undefined,
      estimatedRenovationTime: values.estimatedRenovationTime ? dayjs(values.estimatedRenovationTime).format('YYYY-MM-DD HH:mm:ss') : undefined,
      lookingForwardToStayingTime: values.lookingForwardToStayingTime ? dayjs(values.lookingForwardToStayingTime).format('YYYY-MM-DD HH:mm:ss') : undefined,
      roomSizeDiagram: values.roomSizeDiagram ? formatRelativeUploadData(values.roomSizeDiagram).map(item => item.filePath) : undefined,
      checkInCertificate: values.checkInCertificate ? formatRelativeUploadData(values.checkInCertificate).map(item => item.filePath) : undefined,
    }
  }

  const onSubmit = () => {
    return new Promise((resolve, reject) => {
      form.validateFields().then(values => {
        setLoading(true)
        measureRoomUpdateMeasureDtl(handleValues(values)).then(() => {
          resolve(values)
        }).catch(reject).finally(() => setLoading(false))
      }).catch(reject)
    })
  }

  const onSaveCache = () => {
    const formValues = form.getFieldsValue()
    return Promise.resolve(handleValues(formValues))
  }

  if (props.stepRef) {
    props.stepRef.step4 = {onSubmit, onSaveCache}
  }

  return <div className={styles.stepFormBox}>
    <SGeneralForms
        formConfig={{form}}
        layout={'vertical'}
        configs={[{
          formItem: [
            {
              spanCol: 8,
              label: '装修预算',
              name: 'budget',
              required: true,
              rules: [{required: true, message: '不能为空'}],
              type: 'select',
              comConfig: {
                options: dictionaryData['budget'],
                fieldNames: {label: 'description', value: 'key'}
              }
            },
            {
              spanCol: 8,
              label: '竞品公司',
              name: 'competitorCompany',
              required: true,
              rules: [{required: true, message: '不能为空'}],
              type: 'select',
              comConfig: {
                mode: 'multiple',
                options: dictionaryData['competitorCompanies'],
                fieldNames: {label: 'name', value: 'code'}
              }
            },
            // {
            //   spanCol: 8,
            //   label: '竞品公司备注',
            //   name: 'competitorCompanyOther',
            //   isDeps: true,
            //   deps: (form) => form.getFieldValue('competitorCompany')?.includes('company_other'),
            //   comConfig: {
            //     maxLength: 200,
            //     showCount: true,
            //   }
            // },
            {
              spanCol: 8,
              label: '交房日期',
              name: 'handoverDate',
              required: true,
              rules: [{required: true, message: '不能为空'}],
              type: 'date',
              comConfig: {
                disabledDate
              }
            },
            {
              spanCol: 8,
              label: '预计进场装修时间',
              name: 'expectRenovationDate',
              required: true,
              rules: [{required: true, message: '不能为空'}],
              type: 'date',
              comConfig: {
                disabledDate: (current) => current && current < dayjs().endOf('day')
              }
            },
            {
              spanCol: 8,
              label: '预计定装修时间',
              name: 'estimatedRenovationTime',
              required: true,
              rules: [{required: true, message: '不能为空'}],
              type: 'date',
              comConfig: {
                disabledDate: (current) => current && current < dayjs().endOf('day')
              }
            },
            {
              spanCol: 8,
              label: '期待入住时间',
              name: 'lookingForwardToStayingTime',
              required: true,
              rules: [{required: true, message: '不能为空'}],
              type: 'date',
              comConfig: {
                disabledDate: (current) => current && current < dayjs().endOf('day')
              }
            },
            {
              spanCol: 24,
              label: '量房跟进内容',
              name: 'followContent',
              required: true,
              rules: [{required: true, message: '不能为空'}],
              type: 'textarea',
              comConfig:{
                maxLength: 500,
                showCount: true,
                onChange: (e) => form.setFieldValue('followContent', trimStr(e.target.value))
              }
            },
            {
              spanCol: 24,
              label: '量房尺寸图',
              name: 'roomSizeDiagram',
              required: true,
              rules: [{required: true, message: '不能为空'}],
              children: (<SFormUploadImage
                  url={config.api + '/file-web/file/upload'}
                  multiple={true}
                  beforeUpload={(file) => beforeUpload(file, '.jpg,.jpeg,.png,.bpm')}
                  accept={'.bpm,.jpg,.jpeg,.png'}
                  maxCount={5}
              />)
            },
            {
              spanCol: 24,
              label: '量房打卡证明',
              name: 'checkInCertificate',
              required: true,
              rules: [{required: true, message: '不能为空'}],
              children: (<SFormUploadImage
                  url={config.api + '/file-web/file/upload'}
                  multiple={true}
                  beforeUpload={(file) => beforeUpload(file, '.jpg,.jpeg,.png,.bpm')}
                  accept={'.bpm,.jpg,.jpeg,.png'}
                  maxCount={3}
              />)
            },
          ]
        }]}/>
  </div>
}